/**
 * Whether messaging contacts may be fetched (full permission or legacy thread access).
 * @param {boolean | null} messagingPermission
 * @param {boolean} hasLegacyThreads
 * @returns {boolean}
 */
export function canLoadMessagingContacts(messagingPermission, hasLegacyThreads) {
  return messagingPermission === true || hasLegacyThreads === true;
}
